module.exports = __webpack_public_path__ + "img/user-location-tiny.ead0e73e.png";